//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Reporting Field Comparison Types */
export const ComparisonType = {
    /** Equal */
    EqualTo: 0x0001,

    /** Not equal */
    NotEqualTo: 0x0002,

    /** Starts with */
    StartsWith: 0x0004,

    /** Contains */
    Contains: 0x0008,

    /** Does not contain */
    DoesNotContain: 0x0010,

    /** Is blank */
    IsBlank: 0x0020,

    /** Is not blank */
    IsNotBlank: 0x0040,

    /** Greater than */
    GreaterThan: 0x0080,

    /** Greater than or equal */
    GreaterThanOrEqualTo: 0x0100,

    /** Less than */
    LessThan: 0x0200,

    /** Less than or equal */
    LessThanOrEqualTo: 0x0400,

    /** Ends with */
    EndsWith: 0x0800,

    /** Between */
    Between: 0x1000,

    /** Regular Expression */
    RegularExpression: 0x2000
} as const;

/** Reporting Field Comparison Types */
export const ComparisonTypeDescription: Record<number, string> = {
    1: "Equal To",

    2: "Not Equal To",

    4: "Starts With",

    8: "Contains",

    16: "Does Not Contain",

    32: "Is Blank",

    64: "Is Not Blank",

    128: "Greater Than",

    256: "Greater Than Or Equal To",

    512: "Less Than",

    1024: "Less Than Or Equal To",

    2048: "Ends With",

    4096: "Between",

    8192: "Regular Expression"
};

/** Reporting Field Comparison Types */
export type ComparisonType = number;
